import { render, staticRenderFns } from "./ContentPropertiesEditor.vue?vue&type=template&id=5f67a353&"
import script from "./ContentPropertiesEditor.vue?vue&type=script&lang=ts&"
export * from "./ContentPropertiesEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ContentPropertiesEditor.vue?vue&type=style&index=0&id=5f67a353&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports